module.exports = __webpack_public_path__ + "img/ps5_banner_april_2022_2.afec6c43.png";